import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const SmartCreateFeedbackBannerLoader: LoadableType<
	Omit<
		{
			contentType: 'page' | 'whiteboard' | 'slide';
		},
		'flags'
	>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartCreateFeedbackBanner" */ './SmartCreateFeedbackBanner.tsx'
			)
		).SmartCreateFeedbackBanner,
});
